import ClassNames from "classnames";
import { FunctionComponent, useState } from "react";
import styles from "../stylesheets/components/compact-header-bar.module.css";
import mainMenuStyles from "../stylesheets/components/main-menu.module.css";
import {
  Accommodation,
  ActionLinks,
  ColorScheme,
  Language,
  MainMenuItem,
  PageState,
  Picture,
  ThreeSizes,
} from "../types/index.js";
import { css } from "../utils/emotion.js";
import {
  BarInner,
  Header1LogoContainer,
  Menu,
} from "./HeaderMobile/Header1Mobile.js";
import { Header3LogoContainer } from "./HeaderMobile/Header3Mobile.js";

interface Props {
  actionLinks: ActionLinks;
  activePagePath: string[];
  hasHeaderImage: boolean;
  isPreview: boolean;
  languageId: Language;
  pages: PageState;
  scheme: ColorScheme;
  topLevelMainMenuItems: MainMenuItem[];
  fallbackLanguageId: Language | undefined;
  pageId: string;
  logo: Picture;
  logoSize: ThreeSizes;
  mainPageURL: string | undefined;
  accommodation: Accommodation;
  isCircleHamburger: boolean;
  className?: string;
}

const CompactHeaderBar: FunctionComponent<Props> = ({
  actionLinks,
  logo,
  logoSize,
  activePagePath,
  fallbackLanguageId,
  pages,
  topLevelMainMenuItems,
  isPreview,
  languageId,
  mainPageURL,
  pageId,
  scheme,
  accommodation,
  isCircleHamburger = false,
  className,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const closeMenu = () => setIsMenuOpen(false);

  const LogoContainer = isCircleHamburger
    ? Header3LogoContainer
    : Header1LogoContainer;

  return (
    <div
      className={ClassNames({
        [styles["CompactHeaderBar--height-small"]]: logoSize === "small",
        [styles["CompactHeaderBar--height-medium"]]: logoSize === "medium",
        [styles["CompactHeaderBar--height-big"]]: logoSize === "big",
      })}
    >
      <div
        className={ClassNames(
          styles.CompactHeaderBar,
          mainMenuStyles.MainMenu__CompactHeaderBar,
          css({
            backgroundColor: scheme.main.background,
            color: scheme.main.text,
          }),
          className,
        )}
      >
        <header>
          <BarInner
            accommodation={accommodation}
            isPreview={isPreview}
            logo={logo}
            mainPageURL={mainPageURL}
            logoSize={logoSize}
            actionLinks={actionLinks}
            languageId={languageId}
            closeMenu={closeMenu}
          >
            <LogoContainer
              isMenuOpen={isMenuOpen}
              languageId={languageId}
              toggleMenuOpen={() => setIsMenuOpen((v) => !v)}
            />
          </BarInner>
        </header>
      </div>
      <Menu
        activePagePath={activePagePath}
        fallbackLanguageId={fallbackLanguageId}
        menuItems={topLevelMainMenuItems}
        pages={pages}
        scheme={scheme}
        accommodation={accommodation}
        languageId={languageId}
        whatsAppNumber={undefined}
        actionLinks={actionLinks}
        isPreview={isPreview}
        pageId={pageId}
        isMenuOpen={isMenuOpen}
        closeMenu={closeMenu}
      />
    </div>
  );
};

export default CompactHeaderBar;
